import { render, staticRenderFns } from "./SizeButtons.vue?vue&type=template&id=4765c74d"
import script from "./SizeButtons.vue?vue&type=script&lang=js"
export * from "./SizeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports